module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading":"Loading..."},"es":{"loading":"Cargando..."}}')
  delete Component.options._Ctor
}
